/**
 * Проверка статуса загрузки репозитория (polling).
 */
import { globalSnackbar } from 'components/GlobalSnackbar';
import { getDownloadStatus, loadFilesFromServer, GIT_SELECTED_FILES_KEY } from './gitApi';

import { STATUS_CHECK_INTERVAL_MS } from '../constants';
import type { StatusCheckOpts } from '../types';

let statusCheckInterval: ReturnType<typeof setInterval> | null = null;

export function stopStatusCheck(): void {
  if (statusCheckInterval) {
    clearInterval(statusCheckInterval);
    statusCheckInterval = null;
  }
}

/**
 * Запускает периодическую проверку статуса загрузки.
 */
export function startStatusCheck(taskId: string, opts: StatusCheckOpts): void {
  const { onComplete, setFileTree, requestData } = opts;
  stopStatusCheck();

  statusCheckInterval = setInterval(async () => {
    try {
      const data = await getDownloadStatus(taskId);

      if (data.status === 'done') {
        stopStatusCheck();
        try {
          localStorage.removeItem('gitTaskId');
        } catch (_) {
          /* ignore */
        }
        const children = await loadFilesFromServer(requestData, GIT_SELECTED_FILES_KEY);
        if (children.length > 0) {
          setFileTree(children);
        }
        const win = window as unknown as Window & { updateGitComponent?: () => void };
        if (typeof win.updateGitComponent === 'function') {
          win.updateGitComponent();
        }
        onComplete();
      } else if (data.status === 'failed') {
        stopStatusCheck();
        try {
          localStorage.removeItem('gitTaskId');
        } catch (_) {
          /* ignore */
        }
        globalSnackbar({ message: 'Ошибка загрузки файлов', severity: 'error' });
      }
    } catch (error) {
      console.error('Ошибка проверки статуса:', error);
      globalSnackbar({
        message: `Ошибка проверки статуса: ${(error as Error).message}`,
        severity: 'error',
      });
    }
  }, STATUS_CHECK_INTERVAL_MS);
}
